(function () {
  var PL = window.PL || {};
  var routes = PL.routes || {};

  /* ---------- toast ---------- */
  var toast = document.querySelector('.toast'), tTimer;
  function say(msg, withLink) {
    if (!toast) return;
    toast.textContent = msg;
    if (withLink && routes.cart) {
      var a = document.createElement('a');
      a.href = routes.cart;
      a.textContent = 'View bag';
      toast.appendChild(a);
    }
    toast.classList.add('show');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }

  /* ---------- bag count ---------- */
  function setCount(n) {
    document.querySelectorAll('.bag-count').forEach(function (c) { c.textContent = n; });
    document.querySelectorAll('.bag-btn').forEach(function (b) {
      b.setAttribute('aria-label', 'Bag, ' + n + ' item' + (n === 1 ? '' : 's'));
    });
  }
  function refreshCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function postAdd(body, isJson) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        return data;
      });
    });
  }

  /* ---------- add to bag forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pl-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    postAdd(new FormData(form), false)
      .then(function () { return refreshCount(); })
      .then(function () { say((form.dataset.name || 'Item') + ' added to your bag', true); })
      .catch(function (err) { say(err.message); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- add the whole set ---------- */
  document.querySelectorAll('[data-pl-set]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ids;
      try { ids = JSON.parse(btn.dataset.plSet); } catch (e) { ids = []; }
      if (!ids.length) return;
      btn.classList.add('is-loading');
      postAdd(JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }), true)
        .then(function () { return refreshCount(); })
        .then(function () { say((btn.dataset.name || 'The set') + ' added to your bag', true); })
        .catch(function (err) { say(err.message); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* ---------- mobile drawer ---------- */
  var drawer = document.getElementById('drawer');
  var menuBtn = document.querySelector('.menu-btn');
  if (drawer && menuBtn) {
    var closeDrawer = function () { drawer.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus(); };
    menuBtn.addEventListener('click', function () {
      drawer.hidden = false;
      menuBtn.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a');
      if (first) first.focus();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('.drawer-close') || e.target.closest('a')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
  }

  /* ---------- quantity steppers ---------- */
  function fmt(cents) {
    var v = cents / 100;
    return (PL.currency || '$') + (v % 1 === 0 ? String(v) : v.toFixed(2));
  }
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    function changed() {
      var form = q.closest('form');
      var addBtn = form && form.querySelector('[data-price]');
      if (addBtn) {
        var n = Math.max(1, parseInt(input.value, 10) || 1);
        addBtn.textContent = addBtn.dataset.label + ' — ' + fmt(parseInt(addBtn.dataset.price, 10) * n);
      }
    }
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var v = parseInt(input.value, 10) || 0;
      v = b.dataset.step === 'up' ? v + 1 : Math.max(min, v - 1);
      input.value = v;
      changed();
      if (q.hasAttribute('data-autosubmit')) {
        var f = q.closest('form');
        var upd = f && f.querySelector('[name="update"]');
        if (upd) upd.click();
      }
    });
    input.addEventListener('change', changed);
  });

  /* ---------- product gallery ---------- */
  var mainImg = document.getElementById('pdp-main-img');
  if (mainImg) {
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.thumb').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.src;
        mainImg.alt = t.dataset.alt || '';
      });
    });
  }

  /* ---------- variant select (only for multi-variant products) ---------- */
  document.querySelectorAll('.variant-select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var addBtn = form && form.querySelector('[data-price]');
      if (addBtn && opt) {
        addBtn.dataset.price = opt.dataset.price;
        addBtn.disabled = opt.dataset.available !== 'true';
        addBtn.dataset.label = addBtn.disabled ? 'Sold out' : 'Add to bag';
        var input = form.querySelector('.qty input');
        var n = input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
        addBtn.textContent = addBtn.dataset.label + ' — ' + fmt(parseInt(opt.dataset.price, 10) * n);
      }
    });
  });
  /* ---------- sand: one continuous, tileable texture drawn in the browser ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function lattice(G, R) {
    var v = new Float32Array(G * G); for (var i = 0; i < v.length; i++) v[i] = R();
    return function (x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
      var x0 = ((xi % G) + G) % G, y0 = ((yi % G) + G) % G, x1 = (x0 + 1) % G, y1 = (y0 + 1) % G;
      var u = xf * xf * (3 - 2 * xf), w = yf * yf * (3 - 2 * yf);
      var a = v[y0 * G + x0], b = v[y0 * G + x1], c = v[y1 * G + x0], d = v[y1 * G + x1];
      return a + (b - a) * u + (c - a) * w + (a - b - c + d) * u * w;
    };
  }
  function sandRipples(n) {
    var R = rng(7), nA = lattice(4, R), nB = lattice(6, R), nP = lattice(3, R), nM = lattice(5, R), nQ = lattice(3, R);
    var cv = document.createElement('canvas'); cv.width = cv.height = n;
    var ctx = cv.getContext('2d'), img = ctx.createImageData(n, n), px = img.data, TAU = Math.PI * 2;
    function prof(p) { return Math.sin(p) + 0.32 * Math.sin(2 * p); }
    for (var y = 0; y < n; y++) {
      var fy = y / n;
      for (var x = 0; x < n; x++) {
        var fx = x / n;
        var p1 = TAU * (5 * fx + 3 * fy) + 1.1 * (nA(fx * 4, fy * 4) - 0.5) * TAU;
        var p2 = TAU * (11 * fx + 7 * fy) + 1.6 * (nB(fx * 6, fy * 6) - 0.5) * TAU;
        var calm = 0.55 + 0.6 * nQ(fx * 3, fy * 3);
        var s = (0.62 * prof(p1) + 0.38 * nM(fx * 5, fy * 5) * prof(p2)) * 0.45 * calm + (nP(fx * 3, fy * 3) - 0.5) * 0.4;
        var i = (y * n + x) * 4;
        if (s >= 0) { px[i] = 244 + 5 * s; px[i + 1] = 237 + 7 * s; px[i + 2] = 225 + 10 * s; }
        else { px[i] = 244 + 15 * s; px[i + 1] = 237 + 22 * s; px[i + 2] = 225 + 32 * s; }
        px[i + 3] = 255;
      }
    }
    ctx.putImageData(img, 0, 0);
    return cv;
  }
  function sandGrain(n) {
    var R = rng(11), cv = document.createElement('canvas'); cv.width = cv.height = n;
    var ctx = cv.getContext('2d'), img = ctx.createImageData(n, n), px = img.data;
    for (var i = 0; i < px.length; i += 4) {
      var v = R(), q = R();
      if (q < 0.005) { px[i] = 150; px[i + 1] = 118; px[i + 2] = 80; px[i + 3] = 255 * 0.45 * (0.4 + 0.6 * R()); }
      else if (q > 0.996) { px[i] = px[i + 1] = px[i + 2] = 255; px[i + 3] = 255 * (0.5 + 0.4 * R()); }
      else if (v < 0.45) { px[i] = 120; px[i + 1] = 96; px[i + 2] = 64; px[i + 3] = 255 * (0.45 - v) / 0.45 * 0.07; }
      else if (v > 0.55) { px[i] = px[i + 1] = px[i + 2] = 255; px[i + 3] = 255 * (v - 0.55) / 0.45 * 0.09; }
    }
    ctx.putImageData(img, 0, 0);
    return cv;
  }
  function toUrl(cv) {
    return new Promise(function (res) {
      if (cv.toBlob) cv.toBlob(function (b) { res(b ? URL.createObjectURL(b) : cv.toDataURL()); });
      else res(cv.toDataURL());
    });
  }
  var sandEl = document.querySelector('.pl-sand');
  if (sandEl && document.createElement('canvas').getContext) {
    requestAnimationFrame(function () {
      try {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        Promise.all([toUrl(sandGrain(Math.round(256 * dpr))), toUrl(sandRipples(192))]).then(function (u) {
          sandEl.style.backgroundImage = 'url(' + u[0] + '), url(' + u[1] + ')';
          sandEl.style.backgroundSize = '256px 256px, 768px 768px';
          sandEl.classList.add('is-ready');
        });
      } catch (e) { /* plain sand colour stays */ }
    });
  }

  /* ---------- light that follows the day as you scroll ---------- */
  var glows = {
    dawn: document.querySelector('.pl-glow--dawn'), noon: document.querySelector('.pl-glow--noon'),
    gold: document.querySelector('.pl-glow--gold'), dusk: document.querySelector('.pl-glow--dusk')
  };
  function bell(p, c, w) { var d = Math.abs(p - c) / w; return d >= 1 ? 0 : 0.5 + 0.5 * Math.cos(d * Math.PI); }
  var heroMedia = document.querySelector('.hero-media');
  /* hero video: fades in over the photo once it is actually playing; skipped for reduced motion or data saver */
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo) {
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) {
      heroVideo.parentNode.removeChild(heroVideo);
      heroVideo = null;
    } else {
      heroVideo.muted = true;
      var small = heroVideo.getAttribute('data-small-src');
      if (small && window.innerWidth < 761) { var srcEl = heroVideo.querySelector('source'); if (srcEl) srcEl.src = small; heroVideo.load(); }
      heroVideo.addEventListener('playing', function () { heroVideo.classList.add('is-playing'); });
      var tryPlay = function () { var pr = heroVideo.play(); if (pr && pr.catch) pr.catch(function () { /* autoplay blocked: the photo stays */ }); };
      tryPlay();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          if (!heroVideo) return;
          if (en[0].isIntersecting) tryPlay(); else heroVideo.pause();
        }).observe(heroVideo.parentNode);
      }
    }
  }
  var drift = reduceMotion ? [] : Array.prototype.slice.call(document.querySelectorAll('.story-photo, .sig-photo'));
  var oraStory = document.querySelector('[data-ora]');
  var ticking = false;
  function frame() {
    ticking = false;
    var y = window.pageYOffset || 0, vh = window.innerHeight, max = Math.max(1, document.documentElement.scrollHeight - vh);
    /* the Ora d’Oro story at the top has its own light: the day starts where the story ends */
    var from = oraStory ? Math.max(0, oraStory.getBoundingClientRect().bottom + y - vh) : 0;
    var p = Math.min(1, Math.max(0, (y - from) / Math.max(1, max - from)));
    if (glows.dawn) {
      glows.dawn.style.opacity = bell(p, 0, 0.45);
      glows.noon.style.opacity = bell(p, 0.35, 0.4);
      glows.gold.style.opacity = bell(p, 0.68, 0.38);
      glows.dusk.style.opacity = bell(p, 1, 0.4);
    }
    if (reduceMotion) return;
    if (heroMedia && y < vh * 1.2) heroMedia.style.transform = 'translate3d(0,' + (y * 0.28).toFixed(1) + 'px,0)';
    for (var i = 0; i < drift.length; i++) {
      var r = drift[i].getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var off = (r.top + r.height / 2 - vh / 2) * -0.07;
      drift[i].style.setProperty('--py', Math.max(-36, Math.min(36, off)).toFixed(1) + 'px');
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();

  /* ---------- reveal on scroll ---------- */
  var root = document.documentElement;
  if (root.classList.contains('pl-anim') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- a day in the light: pinned sideways run on desktop, swipe row elsewhere ---------- */
  document.querySelectorAll('[data-pl-day]').forEach(function (sec) {
    var run = sec.querySelector('.day-run'), vp = sec.querySelector('.day-viewport');
    var track = sec.querySelector('.day-track'), line = sec.querySelector('.day-line');
    if (!run || !vp || !track || !track.children.length) return;
    var wide = window.matchMedia ? window.matchMedia('(min-width: 761px)') : { matches: false };
    var pinned = false, dist = 0, pinTop = 0, raf = 0;
    function setP(p) { if (line) line.style.setProperty('--p', p.toFixed(4)); }
    function update() {
      raf = 0;
      if (pinned) {
        var p = Math.min(1, Math.max(0, (pinTop - run.getBoundingClientRect().top) / dist));
        track.style.setProperty('--tx', (-p * dist).toFixed(1) + 'px');
        setP(p);
      } else {
        var max = vp.scrollWidth - vp.clientWidth;
        setP(max > 1 ? vp.scrollLeft / max : 0);
      }
    }
    function measure() {
      var head = document.querySelector('.pl-header-section');
      pinTop = head ? Math.round(head.getBoundingClientRect().height) : 0;
      sec.style.setProperty('--pin-top', pinTop + 'px');
      var want = root.classList.contains('pl-anim') && !reduceMotion && wide.matches;
      pinned = false;
      if (want) {
        sec.classList.add('is-pinned');
        var cs = getComputedStyle(vp);
        dist = Math.max(0, track.offsetWidth + (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) - vp.clientWidth);
        if (dist > 40) {
          pinned = true;
          sec.style.setProperty('--run-h', Math.round(window.innerHeight - pinTop + dist) + 'px');
        }
      }
      if (!pinned) {
        sec.classList.remove('is-pinned');
        sec.style.removeProperty('--run-h');
        track.style.removeProperty('--tx');
      }
      update();
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    vp.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (wide.addEventListener) wide.addEventListener('change', measure);
    /* keyboard: when a card takes focus while pinned, scroll the page so it slides into view */
    track.addEventListener('focusin', function (e) {
      if (!pinned) return;
      var li = e.target.closest ? e.target.closest('.moment') : null;
      if (!li) return;
      var x = li.offsetLeft - track.firstElementChild.offsetLeft;
      var goal = Math.min(dist, Math.max(0, x + li.offsetWidth / 2 - vp.clientWidth / 2));
      var runTop = run.getBoundingClientRect().top + (window.pageYOffset || 0);
      window.scrollTo(0, Math.round(runTop - pinTop + goal));
    });
    measure();
  });
  window.PLready = true;
})();
